import { ILCalendarViewConstants } from './SubComponents/CalendarViewConstants'

export const convertDateToDDMMMYYYY = (date) => {
    const day = date.getDate().toString().padStart(2, '0')
    return `${day}-${
        ILCalendarViewConstants.monthsList[date.getMonth()]
    }-${date.getFullYear()}`
}
